module.exports = __webpack_public_path__ + "img/down_detail_icon.a481f306.svg";